import React from 'react';
import { useDispatch } from 'react-redux';
import i18next from 'i18next';
import useTypedSelector from 'hooks/useTypedSelector';

import { onResetPassword } from 'redux/actions/auth.actions';
import ForgotPasswordView from 'views/public/ForgotPasswordView';
import LayoutContainer from 'containers/LayoutContainer';

const ForgotPasswordContainer: React.FC = () => {
  const dispatch = useDispatch();

  const { loading, message } = useTypedSelector((state) => state.auth);

  const success = message === i18next.t<string>('FORGOT_PASSWORD:SUCCESS_MESSAGE');

  const handleResetPassword = (email: string) => {
    dispatch(onResetPassword(email));
  };

  return (
    <LayoutContainer isPublic title={i18next.t('FORGOT_PASSWORD:TITLE', 'Recuperar contraseña')}>
      <ForgotPasswordView
        onSubmit={handleResetPassword}
        loading={loading}
        success={success}
        error={message && !success ? message : null}
      />
    </LayoutContainer>
  );
};

export default ForgotPasswordContainer;
